<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="450px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <div>
            <h1 class="title">{{item.text}}</h1>
            <p class="info-tip" v-for="(ele, index) in item.list" :key="index">{{ele}}</p>
          </div>
          <div>
            <el-image style="width: 100%; height: 100%" fit='contain' :src="item.rightImage"></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 商城下载 start -->
    <div class="down-content">
      <p class="content-h1">在线商场软件下载</p>
      <el-button type="primary" @click="toLogin">立即下载</el-button>
      <div class="icon-box">
        <div v-for="(item, index) in iconList" :key="index">
          <img :src="item.url" alt="">
          <p>{{item.text}}</p>
        </div>
      </div>
      <p class="content-foot">丰富的营销插件</p>
    </div>
    <!-- 商城下载 end -->

    <!-- 软件下载 start -->
    <div class="down">
      <div>
        <h1 class="down-h1">软件下载</h1>
        <span class="down-span">办公软件、电商软件、管理软件，助您畅享软件便利</span>
      </div>

      <div class="down-list">
        <div class="list-item" v-for="(item, index) in listData" :key="index">
          <img class="list-img" :src="item.imageUrl" />
          <p v-for="(ele, index) in item.text" :key="index">{{ele}}</p>
          <el-button class="list-item-btn" type="primary" @click="toLogin" plain>立即下载</el-button>
        </div>
      </div>
      <!-- foot btn start -->
        <div class="foot-btn">
          <el-button type="primary"  @click="toLogin">更多软件</el-button>
        </div>
      <!-- foot btn end -->
    </div>
    <!-- 软件下载 end -->


  </div>
</template>

<script>
import banner1 from '@/assets/imgs/demo.png';
import banner2 from '@/assets/imgs/demo-right.png';

import list1 from '@/assets/imgs/list-1.png';
import list2 from '@/assets/imgs/list-2.png';
import list3 from '@/assets/imgs/list-3.png';
import list4 from '@/assets/imgs/list-3.png';

import icon1 from '@/assets/imgs/icon-1.png';
import icon2 from '@/assets/imgs/icon-2.png';
import icon3 from '@/assets/imgs/icon-3.png';
import icon4 from '@/assets/imgs/icon-4.png';
import icon5 from '@/assets/imgs/icon-4.png';
export default {
  data() {
    return {

      carouselItem: [
        {
          bgcIma: banner1,
          text: '软件下载',
          rightImage: banner2,
          list: ['会员下载有优惠']
        }
      ],
      listData: [
        {
          text: ['运维管理软件', '企业大数据运维管理', '会员优惠价：2000元'],
          imageUrl: list1
        },
        {
          text: ['建筑行业软件', '建筑行业实时监测软件', '会员优惠价：3000元'],
          imageUrl: list2
        },
        {
          text: ['粮牧监测软件', '农产畜牧业智能检测软件', '会员优惠价：900元'],
          imageUrl: list3
        },
        {
          text: ['船只管理软件', '远洋船只检测管理软件', '会员优惠价：3000元'],
          imageUrl: list4
        }
      ],
      iconList: [
        {
          url: icon1,
          text: '生成小程序'
        },
        {
          url: icon2,
          text: '可视化修改'
        },
        {
          url: icon3,
          text: '表单类收集'
        },
        {
          url: icon4,
          text: '数据储存'
        },
        {
          url: icon5,
          text: '营销推广'
        }
      ]
    }
  },

  methods: {
    toLogin() {
      this.$router.push({
        path: '/userlogin'
      })
    },
  }
}
</script>


<style scoped>
.carousel-box {
   overflow: hidden;
 }
 .item-bgc {
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
 }
 .info-box {
   width: 60%;
   height: 70%;
   background-color: transparent;
   position: absolute;
   left: 50%;
   top: 100px;
   transform: translateX(-50%);
   display: flex;
 }
 .info-box div {
   flex: 1;
   color: #fff;
   font-size: 18px;
 }
 .title {
   font-size: 46px;
   padding: 20px 0;
 }
 .info-tip {
   padding: 5px 0;
 }

 .down-content {
   padding: 60px 250px 30px 250px;
   text-align: center;
 }
 .content-h1 {
   font-size: 36px;
   padding-bottom: 30px;
 }
 .content-foot {
   padding: 30px 0;
   font-size: 28px;
   font-weight: 600;
   color: rgb(53, 53, 53);
 }

 .icon-box {
   display: flex;
   justify-content: space-around;
   padding: 40px 0;
 }

  .down {
    padding: 30px 250px 30px 250px;
    background-color: rgb(241, 241, 241);
    box-sizing: border-box;
  }
  .down-h1 {
    color: rgb(43, 43, 43);
    font-size: 26px;
    font-weight: bold;
  }
  .down-span {
    color: rgb(75, 75, 75);
    font-size: 18px;
  }
  .down-list {
    padding-top: 80px;
    display: flex;
    justify-content: space-between;
  }
  .list-item {
    width: 240px;
    padding: 5px 10px 10px 10px;
    background-color: #fff;
    box-sizing: border-box;
    text-align: center;
  }
  .list-img {
    width: 100%;
    padding-bottom: 30px;
  }
  .list-item p {
    padding: 5px 0;
    text-align: center;
    color: rgb(203, 203, 203);
  }
  .list-item p:nth-child(2) {
    color: rgb(33, 33, 33);
    font-size: 20px;
  }
  .list-item-btn {
    width: 150px;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .foot-btn {
    padding: 60px 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/down.vue